"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputLabel = function InputLabel(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      htmlFor = _ref.htmlFor,
      text = _ref.text,
      restOfProps = _objectWithoutProperties(_ref, ["className", "disabled", "error", "htmlFor", "text"]);

  if (!text) return null;
  var labelClasses = (0, _classnames.default)(className, {
    'pds-input-label': true,
    'pds-input-label--error': error,
    'pds-input-label--disabled': disabled
  });
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("label", _extends({}, restOfProps, {
    className: labelClasses,
    htmlFor: htmlFor
  }), text));
};

InputLabel.propTypes = {
  /**
   * Applies additional CSS classes to the HTML label element.
   */
  className: _propTypes.string,

  /**
   * Applies additional CSS classes to the label element to show a disabled state.
   */
  disabled: _propTypes.bool,

  /**
   * Applies additional CSS classes to the label element to show an error state.
   */
  error: _propTypes.bool,

  /**
   * Accessibility label applied to the label element describing the target input field element.
   */
  htmlFor: _propTypes.string.isRequired,

  /**
   * The text to be rendered on the HTML label element.
   */
  text: _propTypes.string
};
InputLabel.defaultProps = {
  className: null,
  disabled: false,
  error: false,
  text: ''
};
var _default = InputLabel;
exports.default = _default;
